export default __webpack_public_path__ + "static/media/bg7.385f3272.jpg";